<template>
  <div v-if="noData">
    <div class="typo-super-tiny no-inspections">
      {{ $t('empty_states.issues_in_progress.title') }}
    </div>
  </div>
  <apexchart
    v-else
    class="condition-index"
    :height="height"
    :options="chartOptions"
    :series="series"
    type="area"
    :width="width"
  />
</template>

<script setup>
import VueApexCharts from 'vue3-apexcharts';
import { computed } from 'vue';

import {
  condition4ColoursIndex,
  condition5ColoursIndex,
  fillOptions,
  strokeOptions,
} from '@/functions/chart_config';

const apexchart = VueApexCharts;

const props = defineProps({
  /** Specify the height of the chart */
  height: { type: Number, required: false, default: 45 },
  /** Unique Id for the chart */
  id: { type: String, required: true, default: null },
  /** The chart data */
  series: { type: Array, required: true },
  /** Specify the width of the chart */
  width: { type: Number, required: false, default: 70 },
});

const noData = computed(() => {
  return props.series[0].count === 0 && props.series[1].count === 0;
});

const noInspectionWidth = computed(() => {
  return `${props.width}px`;
});

/**
 * Chart options
 * reference: https://apexcharts.com/docs/  -> Options (reference)
 */
const chartOptions = {
  chart: {
    id: props.id,
    foreColor: '#989799',
    toolbar: { show: false },
    zoom: { enabled: false },
  },
  yaxis: {
    min: 0,
    labels: { show: false },
  },
  xaxis: {
    labels: { show: false },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  legend: { show: false },
  dataLabels: { enabled: false },
  stroke: {
    ...strokeOptions,
    width: 1,
  },
  grid: {
    show: false,
    padding: {
      left: -10,
      right: 0,
      top: -25,
      bottom: -30,
    },
  },
  colors: [],
  fill: fillOptions,
  tooltip: { enabled: false },
};

/**
 * Override chart options based on the condition id
 */
if (props.id === 'condition_5') {
  chartOptions.fill.colors = condition5ColoursIndex;
  chartOptions.colors = condition5ColoursIndex;
} else {
  chartOptions.fill.colors = condition4ColoursIndex;
  chartOptions.colors = condition4ColoursIndex;
}
</script>

<style lang="scss">
@import '@/stylesheets/global';
@import '@/stylesheets/components/apexchart_override.scss';

.no-inspections {
  font-style: italic;
  opacity: 0.3;
  text-align: center;
  width: v-bind(noInspectionWidth);
}
</style>
